import { render, staticRenderFns } from "./block-user-sessions.vue?vue&type=template&id=fcf5fbf2&scoped=true&lang=pug"
import script from "./block-user-sessions.vue?vue&type=script&lang=js"
export * from "./block-user-sessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf5fbf2",
  null
  
)

export default component.exports